







































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import {ILicences, ILicenceRequest} from '../shared/services/models/Licences';
import {IVersions} from '../shared/services/models/Versions';
import {IChangeLog} from '../shared/services/models/ChangeLog';
import APIService from '../services/api';

// The @Component decorator indicates the class is a Vue component
@Component({
    components: {
        // @ts-ignore
        CopyrightComponent : require('@/components/Copyright').default,
    },
    computed: {
        ...mapState(['licences', 'prices', 'versions']),
    },
    methods: {
        ...mapActions(['updateLicences', 'updatePrices', 'updateVersions']),
    },
})
export default class About extends Vue {
    private licensesUI = require('../assets/ui-licenses.json');

    private licences!: ILicences;
    private versions!: IVersions;
    private changeLog: IChangeLog = {
        updated: 'never',
        services: [],
    };

    private requestLicences: ILicences = {
                                            srt: false,
                                            rist: false,
                                            rtmp: false,
                                            hls: false,
                                            cinegy_route: false,
                                            capture_playback: false,
                                            relay: false,
                                            tudp: false,
                                            zixi: false,
                                            ndi: false,
                                            biss: false,
                                            interfaces: 0,
                                            multi_output: false,
                                            trial: false,
                                            trial_end_date: undefined,
                                        };
    private licenceRequest: string = '';
    private licenceResponse: string = '';
    private prices!: { [key: string]: string };

    private mounted() {
        APIService.GetChangeLog().then((cl) => this.changeLog = cl);
        // @ts-ignore
        this.updatePrices();
        // @ts-ignore
        this.updateVersions();

        if (this.licences.interfaces === 0) {
            // @ts-ignore
            this.updateLicences();

            setTimeout(() => {
                this.requestLicences.srt = this.licences.srt;
                this.requestLicences.rist = this.licences.rist;
                this.requestLicences.rtmp = this.licences.rtmp;
                this.requestLicences.hls = this.licences.hls;
                this.requestLicences.biss = this.licences.biss;
                this.requestLicences.ndi = this.licences.ndi;
                this.requestLicences.cinegy_route = this.licences.cinegy_route;
                this.requestLicences.capture_playback = this.licences.capture_playback;
                this.requestLicences.relay = this.licences.relay;
                this.requestLicences.tudp = this.licences.tudp;
                this.requestLicences.interfaces = this.licences.interfaces;
                this.requestLicences.multi_output = this.licences.multi_output;
            }, 500);
        } else {
            this.requestLicences.srt = this.licences.srt;
            this.requestLicences.rist = this.licences.rist;
            this.requestLicences.rtmp = this.licences.rtmp;
            this.requestLicences.hls = this.licences.hls;
            this.requestLicences.biss = this.licences.biss;
            this.requestLicences.ndi = this.licences.ndi;
            this.requestLicences.cinegy_route = this.licences.cinegy_route;
            this.requestLicences.capture_playback = this.licences.capture_playback;
            this.requestLicences.relay = this.licences.relay;
            this.requestLicences.tudp = this.licences.tudp;
            this.requestLicences.interfaces = this.licences.interfaces;
            this.requestLicences.multi_output = this.licences.multi_output;
        }
    }

    private typeVariant(type: string): string {
        switch (type.toLowerCase()) {
            case 'bug': return 'danger';
            case 'feature': return 'success';
             case 'info': return 'info';
            default: return 'info';
        }
    }

    private get UpdateCost(): number {
        let ret: number = 0;

        Object.keys(this.requestLicences).forEach((key) => {
            // @ts-ignore
            if (typeof(this.requestLicences[key]) === 'boolean' && this.requestLicences[key] && !this.licences[key]) {
                ret += parseInt(this.prices[key].substring(1), 10);
                // @ts-ignore
            } else if (parseInt(this.requestLicences[key], 10) > parseInt(this.licences[key], 10)) {
                // @ts-ignore
                ret += parseInt(this.prices[key].substring(1), 10) * (parseInt(this.requestLicences[key], 10) - parseInt(this.licences[key], 10));
            }
        });

        return ret;
    }

    private get LicensesForVersions(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};
        const zixiFeeder: string = 'zixi_feeder';
        const zixiClient: string = 'zixi_client';
        Object.keys(this.licences).forEach((key) => {
            if (key === 'zixi') {
                ret[zixiFeeder] = zixiFeeder;
                ret[zixiClient] = zixiClient;
            } else {
                ret[key] = key;
            }
        });

        return ret;
    }

    private setRequestValue(key: string, type: string, value: any) {
        // @ts-ignore
        this.requestLicences[key] = value;
        const cost = this.UpdateCost;
    }

    private async sendRequest(): Promise<void> {
        const req: ILicenceRequest = await APIService.LicenceRequest(this.requestLicences);

        this.licenceRequest = JSON.stringify(req);
        // @ts-ignore
        this.$refs['licence-request-modal-result'].show();
    }

    private async processLicneceResponse(): Promise<void> {
        await APIService.LicenceReponse(JSON.parse(this.licenceResponse));
        // @ts-ignore
        this.updateLicences();
    }

    private get Versions(): { [key: string]: string } {
        const ret: { [key: string]: string } = {};

        return ret;
    }

    private getFeatureVersion(key: string): string {
        if (key === 'interfaces') {
            key = 'application';
        }
        if (this.versions && this.versions.hasOwnProperty(key)) {
            // @ts-ignore
            return this.versions[key];
        }

        return 'n/a';
    }

    private getLicenseNameOverload(name: string) {
        if (name === 'cinegy_route') {
            return 'router';
        } else if (name === 'capture_playback') {
            return 'capture and playback';
        } else if (name === 'multi_output') {
            return 'multiple outputs per interface';
        } else if (name === 'trial_end_date') {
            return 'trial end date';
        } else if (name === 'tudp') {
            return 'timeshifter (memory)';
        } else if (name === 'biss') {
            return 'BISS-1 decoding';
        } else if (name === 'zixi_feeder') {
            return 'zixi feeder';
        } else if (name === 'zixi_client') {
            return 'zixi client';
        }
        return name;
    }
}
